import { render, staticRenderFns } from "./BaseSubNavContainer.vue?vue&type=template&id=44cc234e"
import script from "./BaseSubNavContainer.vue?vue&type=script&lang=ts"
export * from "./BaseSubNavContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports